import {
  CmpSelectBox,
  CmpTextField,
  CmpButton,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  NotificationPickingPendingDetailObjAuto_Set,
  NotificationData_Set,
  NotificationPickingPendingAuto_Init,
} from "./SliceNotification";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import useMediaQuery from "@mui/material/useMediaQuery";
import Notification_Breadcrumbs from "./Notification_BreadCrumbs";
import { GridDataPickingPendingColumns_Def } from "./Action";
import { PickingHeadCard } from "./PickingHeadCard";
import PickingHead from "./PickingHead";
import NotificationModal from "./component/NotificationModal";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import DashBoardBreadCrumbs from "../WmsDashboard/processComponent/DashBoardBreadCrumbs";
import Picking_Breadcrumbs from "../Picking/Picking_BreadCrumbs";

export default function PickingPendingList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const aMediaQuery = useMediaQuery("(max-width:900px)");
  const PickingPendingFocusOnLoad = useRef(null);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const location = useLocation();
  // const vRdxDetail = useSelector(
  //   (state) => state.SliceNotification.value.NotificationHead
  // );
  const vRdxSliceData = useSelector(
    (state) => state.SliceNotification.value.NotificationData
  );
  //  const vRdxDetailObj = useSelector(
  //   (state) => state.SliceNotification.value.NotificationPickingPending
  // );
  // const vRdxSlicePickingPending = useSelector(
  //   (state) => state.SliceNotification.value.NotificationPickingPending
  // );

  // Navigate from DashBoard & Picking - Dec 24 2025 by Ramesh Sir
  const headObj = location.state;
  //
  const [sLoadObj, setLoadObj] = useState(vRdxSliceData);
  const [sGridrows, setGridrows] = useState([]);

  const [sAisle, setAisle] = useState([]);
  const [sLevel, setLevel] = useState([]);
  const [sNextPage, setNextPage] = useState(false); //Navigate page

  const fOnChangeSelectAisleCd = async (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    let PickingLevelArr = await GetPickingLevelList(e.target.value);
    await GetSummaryList(e.target.value, PickingLevelArr[0].UId);
    setLoadObj((obj) => ({
      ...obj,
      LevelCd: PickingLevelArr[0].UId,
    }));
  };
  const fOnChangeSelect = async (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    await GetSummaryList(sLoadObj.AisleCd, e.target.value);
  };
  const fOnChangeInput = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
    }
  };

  const fOnRowClick = (e) => {
    dispatch(NotificationData_Set(sLoadObj));
    dispatch(
      NotificationPickingPendingDetailObjAuto_Set({
        ItmCd: e.row.ItmCd,
        ItmName: e.row.ItmName,
        CardID: e.row.CardID,
        F_AisleCd: e.row.F_AisleCd,
        AisleName: e.row.AisleName,
        F_Level: e.row.F_Level,
        Level: e.row.Level,
        F_BinCd: e.row.F_BinCd,
        BinName: e.row.BinName,
        BaseQty: e.row.BaseQty,
        PickedQty: e.row.PickedQty,
        BalQty: e.row.BalQty,
        SuppRefno1: e.row.SuppRefno1,
        DropID: e?.row?.DropID || "",
      })
    );

    setNextPage(true);
    fNext(true);
  };

  //1st load
  const onLoadCall = async (e) => {
    let PickingAisleList = await GetPickingAisleList();
    let iAisleCd =
      vRdxSliceData.AisleCd == ""
        ? PickingAisleList[0]?.UId
        : vRdxSliceData.AisleCd;
    let PickingLevelArr = await GetPickingLevelList(iAisleCd);
    let iLevelCd =
      vRdxSliceData.LevelCd == ""
        ? PickingLevelArr[0]?.UId
        : vRdxSliceData.LevelCd;

    setLoadObj((obj) => ({
      ...obj,
      AisleCd: iAisleCd,
      LevelCd: iLevelCd,
      Type: headObj?.A_Typ,
    }));
    dispatch(
      NotificationData_Set({
        AisleCd: iAisleCd,
        LevelCd: iLevelCd,
        Type: headObj?.A_Typ,
      })
    );
    let summaryResp = await GetSummaryList(iAisleCd, iLevelCd);

    dispatch(NotificationPickingPendingAuto_Init());
    // if(iAisleCd == "" && iLevelCd =="" &&summaryResp.length == 0) {
    //   fPrevious()
    // }
  };

  const ifArrayEmpty = async (e) => {
    let PickingAisleList = await GetPickingAisleList();
    let iAisleCd = PickingAisleList[0]?.UId || "";
    let PickingLevelArr = await GetPickingLevelList(iAisleCd);
    let iLevelCd = PickingLevelArr[0]?.UId || "";
    setLoadObj((obj) => ({
      ...obj,
      AisleCd: iAisleCd,
      LevelCd: iLevelCd,
      Type: headObj?.A_Typ,
    }));
    dispatch(
      NotificationData_Set({
        AisleCd: iAisleCd,
        LevelCd: iLevelCd,
        Type: headObj?.A_Typ,
      })
    );
    let summaryResp = await GetSummaryList(iAisleCd, iLevelCd);
  };
  //API NOTIFICATION_PICKINGPENDINGITEMS_GETROW
  const GetSummaryList = async (xAisleCd, xLevelCd) => {
    let vSummaryListObj = {
      VocTyp: headObj?.A_VocTyp,
      VocNo: headObj?.A_VocNo,
      AisleCd: xAisleCd,
      LevelCd: xLevelCd,
      UserCd: vRdxuserInfo.UserID,
    };
    const vSummaryList = await fExecuteAPI(
      "NOTIFICATION_PICKINGPENDINGITEMS_GETROW",
      vSummaryListObj
    );
    if (vSummaryList.Type == "SUCCESS") {
      let GridID =
        vSummaryList.ResultSet.length == 0
          ? []
          : vSummaryList.ResultSet?.map((obj, i) => ({
              ...obj,
              id: i + 1,
            }));
      if (
        xAisleCd == "" &&
        xLevelCd == "" &&
        vSummaryList.ResultSet.length == 0
      ) {
        fPrevious();
      } else if (vSummaryList.ResultSet.length == 0) {
        ifArrayEmpty();
      }
      setGridrows(GridID);
      return GridID;
    } else {
      fAlertToast(
        "FAILED",
        vSummaryList.Message ||
          vSummaryList.response.data.Status ||
          "Error in loading summarylist"
      );
      setGridrows([]);
      return [];
    }
  };
  //API NOTIFICATION_PICKINGAISLELIST_GETROW
  const GetPickingAisleList = async () => {
    let vPickingAisleListObj = {
      VocTyp: headObj?.A_VocTyp,
      VocNo: headObj?.A_VocNo,
      UserCd: vRdxuserInfo.UserID,
    };
    const vPickingAisleList = await fExecuteAPI(
      "NOTIFICATION_PICKINGAISLELIST_GETROW",
      vPickingAisleListObj
    );
    if (vPickingAisleList.Type == "SUCCESS") {
      setAisle(vPickingAisleList.ResultSet);
      return vPickingAisleList.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vPickingAisleList.Message ||
          vPickingAisleList.response.data.Status ||
          "Error in loading PickingAisleList"
      );
      setAisle([]);
      return [];
    }
  };

  //API NOTIFICATION_PICKINGLEVELLIST_GETROW
  const GetPickingLevelList = async (xAisleCd) => {
    let vPickingLevelListObj = {
      VocTyp: headObj?.A_VocTyp,
      VocNo: headObj?.A_VocNo,
      UserCd: vRdxuserInfo.UserID,
      AisleCd: xAisleCd,
    };
    const vPickingLevelList = await fExecuteAPI(
      "NOTIFICATION_PICKINGLEVELLIST_GETROW",
      vPickingLevelListObj
    );
    if (vPickingLevelList.Type == "SUCCESS") {
      setLevel(vPickingLevelList.ResultSet);
      return vPickingLevelList.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vPickingLevelList.Message ||
          vPickingLevelList.response.data.Status ||
          "Error in loading PickingLevelList"
      );
      setLevel([]);
      return [];
    }
  };

  const fNext = (xNavigate) => {
    if (
      !!xNavigate ||
      headObj.A_PKL_DocStatus == "POST" ||
      sGridrows.length == 0
    ) {
      //navigate("/PickingDetail");

      //detailObj for pickingPendingList (make resuable) by Ramesh Sir on Dec 26 2025
      navigate("/PickingDetail", {
        state: {
          ...location.state,
          current: "PickingDetail",
        },
      });
    } else {
    }
  };
  const fPrevious = async (e) => {
    if (headObj?.entrySource == "Dashboard") {
      navigate("/wmsDashoard");
    } else if (headObj?.entrySource == "Picking") {
      navigate("/Picking");
    } else {
      navigate("/Notification");
    }
  };
  useEffect(() => {
    onLoadCall();
  }, []);
  useEffect(() => {
    PickingPendingFocusOnLoad.current?.focus();
  }, []);

  const [GridDataPickingPendingColumns, setGridDataPickingPendingColumns] =
    useState(GridDataPickingPendingColumns_Def);

  // modal start

  const [showModal, setShowModal] = useState(false);
  console.log(sAisle);

  // modal end

  // useEffect(() => {
  //   GetGitterColumns(
  //     setGridDataPickingPendingColumns,
  //     "NOTIFICATION_PICKING_PENDING",
  //     GridDataPickingPendingColumns
  //   );

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  console.log(headObj);

  return (
    <div className={vMediaQuery ? "" : "container-fluid my-1"}>
      <Grid
        container
        spacing={vMediaQuery ? 0 : 2}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item md={12} xs={12} textAlign={"start"}>
          {headObj?.entrySource == "Dashboard" ? (
            <DashBoardBreadCrumbs />
          ) : headObj?.entrySource == "Picking" ? (
            <Picking_Breadcrumbs />
          ) : (
            <Notification_Breadcrumbs />
          )}
        </Grid>
      </Grid>

      <div style={{ margin: "auto", width: "95%" }}>
        {aMediaQuery && (
          <Grid
            container
            columns={{ xs: 12, sm: 12, md: 12 }}
            marginBottom={"10px"}
          >
            <Grid item md={9} xs={6} textAlign={"start"} marginTop={1}>
              <CmpTypographyField xText={"DOC.No : " + headObj?.A_VocNo} />
            </Grid>
            <Grid item md={3} xs={6} textAlign={"end"}>
              <CmpButton
                xbtnName="Summary"
                xOnClick={() => {
                  setShowModal(true);
                }}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
          </Grid>
        )}

        <Grid
          container
          spacing={vMediaQuery ? 0.5 : 2}
          columns={{ xs: 12, sm: 12, md: 12 }}
          alignItems={"center"}
          className="detailCard"
          marginTop={0.5}
        >
          {!aMediaQuery && (
            <Grid item md={2} sm={4} xs={3} textAlign={"start"}>
              <Button
                variant="contained"
                // onClick={() => {
                //  setShowModal(true);
                // }}
              >
                {"DOC.No : " + headObj?.A_VocNo}
              </Button>
            </Grid>
          )}

          <Grid
            item
            md={3}
            sm={4}
            xs={6}
            className={headObj?.A_Typ == "A" ? "" : "hide-content"}
          >
            <CmpSelectBox
              xref={PickingPendingFocusOnLoad}
              xLabelText="Aisle"
              xValue={sLoadObj.AisleCd}
              xOnChange={(event) => fOnChangeSelectAisleCd(event)}
              xName={"AisleCd"}
              xData={sAisle}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
              xsize={vMediaQuery ? "small" : ""}
            />
          </Grid>
          <Grid
            item
            md={3}
            sm={4}
            xs={6}
            className={headObj?.A_Typ == "A" ? "" : "hide-content"}
          >
            <CmpSelectBox
              xLabelText="Level"
              xValue={sLoadObj.LevelCd}
              xOnChange={(event) => fOnChangeSelect(event)}
              xName={"LevelCd"}
              xData={sLevel}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
              xsize={vMediaQuery ? "small" : ""}
            />
          </Grid>
          <Grid
            item
            md={2}
            sm={4}
            xs={4}
            className={
              headObj?.A_Typ == "A"
                ? "xs-screen-hide"
                : "hide-content xs-screen-hide"
            }
          >
            <CmpTextField
              xLabelText={"Type"}
              xVariant={"outlined"}
              xValue={headObj?.A_Typ == "A" ? "AUTO" : "MANUAL"}
              xOnChange={(event) => fOnChangeInput(event)}
              xReadOnly={true}
              xType={"text"}
              xName={"A_Typ"}
              xOnKeyUp={(e) => {
                fOnKeyUp(e);
              }}
              xsize="small"
            />
          </Grid>
          {!aMediaQuery && (
            <Grid
              item
              md={headObj?.A_Typ != "A" ? 10 : 2}
              xs={2}
              textAlign={"end"}
            >
              <CmpButton
                xbtnName="Summary"
                xOnClick={() => {
                  setShowModal(true);
                }}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
          )}
        </Grid>

        <div
          style={{
            height: aMediaQuery ? "65vh" : "72vh",
            overflowY: "auto",
            marginTop: "14px",
            padding: "8px",
          }}
        >
          <Grid container spacing={1}>
            {Array.isArray(sGridrows) &&
              sGridrows?.length > 0 &&
              sGridrows?.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <DetailCardComp
                    data={item}
                    onClick={(item) => {
                      fOnRowClick({ row: item });
                    }}
                    headerLabel={item.ItmName}
                    content={
                      <Grid container spacing={1}>
                        <DetailInputDisplay
                          label="Card ID"
                          value={item.CardID}
                        />
                        <DetailInputDisplay
                          label="Ref.No"
                          value={item.SuppRefno1}
                        />
                        <DetailInputDisplay
                          label="Aisle / Bin"
                          value={`${item.AisleName} / ${item.BinName}`}
                        />
                        <DetailInputDisplay
                          label="Picked / Pick"
                          value={` ${item.PickedQty} / ${item.BaseQty} = ${item.BalQty}`}
                        />
                        <DetailInputDisplay
                          label="Bin Name"
                          value={item.BinName}
                        />
                        <DetailInputDisplay
                          label="Item Code"
                          value={item.ItmCd}
                        />
                      </Grid>
                    }
                  />
                </Grid>
              ))}
          </Grid>
        </div>

        {/* <Box
          sx={{ height: vMediaQuery ? "59vh" : "70vh", width: "100%" }}
          className="bin-transfer-data"
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            rows={sGridrows}
            columns={GridDataPickingPendingColumns}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            hideFooter={sGridrows.length < 100}
            onRowClick={fOnRowClick}
            components={
              !vMediaQuery && {
                Toolbar: GridToolbar,
              }
            }
          />
        </Box> */}
        <Box
          sx={{ flexGrow: 1 }}
          className={vMediaQuery ? "mt-1" : "btn-txt-center-mt"}
        >
          <Grid
            container
            spacing={1}
            columns={{ xs: 4, sm: 4, md: 4 }}
            className="text-center "
          >
            <Grid item xs={2} textAlign={"start"}>
              <CmpButton
                xbtnName="Previous"
                xOnClick={fPrevious}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
            <Grid item xs={2} textAlign={"end"}>
              <CmpButton
                xbtnName="Next"
                xOnClick={(e) => {
                  fNext(sNextPage);
                }}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
          </Grid>
        </Box>

        <NotificationModal
          xOpen={showModal}
          fCloseModal={() => {
            setShowModal(false);
          }}
          xTitle="Filter"
          component={
            <>
              <PickingHead />
            </>
          }
        />
      </div>
    </div>
  );
}
